function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#37BEB7;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0,2.7c0-1.1,0.9-2,2-2h16c1.1,0,2,0.9,2,2v12c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2.7z M6,2.7v12h8v-12H6z M2,3.7v2h2v-2H2 z M2,7.7v2h2v-2H2z M2,11.7v2h2v-2H2z M16,3.7v2h2v-2H16z M16,7.7v2h2v-2H16z M16,11.7v2h2v-2H16z M8,5.7l5,3l-5,3V5.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Laag_2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 17.3,
  cy: 16.5,
  r: 4.8
}), /*#__PURE__*/React.createElement("polygon", {
  points: "17.9,15.9 17.9,13.5 16.7,13.5 16.7,15.9 14.3,15.9 14.3,17.1 16.7,17.1 16.7,19.6 17.9,19.6 17.9,17.1  20.3,17.1 20.3,15.9  "
})));

var SvgAddVideo = function SvgAddVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.1 23.1",
    style: {
      enableBackground: "new 0 0 23.1 23.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddVideo.df4f0d04.svg";
export { ForwardRef as ReactComponent };